import { Button } from '@/components/ui/button'
import { LucideIcon } from 'lucide-react'
import { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: LucideIcon | string
  title: string
  description: string
  actionLabel: string
  onAction: () => void
  minHeight?: string
  children?: ReactNode
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  minHeight = 'min-h-[400px]',
  children,
}: EmptyStateProps) {
  return (
    <div
      className={`flex ${minHeight} flex-col items-center justify-center px-4 text-center`}
    >
      {/* Icon */}
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[#0033A0]/10">
        {typeof Icon === 'string' ? (
          <span className="text-4xl">{Icon}</span>
        ) : Icon ? (
          <Icon className="h-8 w-8 text-[#0033A0]" />
        ) : null}
      </div>

      {/* Title */}
      <h2 className="mb-2 text-xl font-semibold text-black">{title}</h2>

      {/* Description */}
      <p className="mb-6 max-w-md text-sm text-[#666666]">{description}</p>

      {/* Action Button */}
      <Button onClick={onAction} className="bg-[#0033A0] hover:bg-[#0033A0]/90">
        {actionLabel}
      </Button>

      {/* Optional children */}
      {children}
    </div>
  )
}
